/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ChaptersourceTypeSvg = () => (
  <svg
    width="1.1em"
    height="1.1em"
    fill="currentColor"
    viewBox="0 0 17 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.805664" width="16.1943" height="16.1943" rx="8.09717" fill="#currentColor" opacity="0.20"/>
    <circle cx="8.09375" cy="8.90283" r="3" fill="#currentColor"/>
  </svg>
);

export const ChaptersourceTypeIcon = props => <Icon component={ChaptersourceTypeSvg} {...props} />;
